/**
 * author andre.pitombeira
 */
'use strict';
export const OC_API = {
  TOKEN: '6ed3031dff3296353aa6a0f7ace485b6',
  DATE_FORMAT: 'YYYY-MM-DD[T]HH:mm:ss[Z]',
  DATE_FORMAT_NO_TIMEZONE: 'YYYY-MM-DD[T]HH:mm:ss',
  JUST_DATE_FORMAT: 'YYYY-MM-DD',
  JUST_DATE_WITH_DOTS_FORMAT: 'DD.MM.YYYY',
};

export const BC_API = {
  TOKEN: '97160774e275d555c2bd8d98181efb96',
  JUST_DATE_FORMAT: 'YYYY-MM-DD',
};

export const API_V2_HEADER = {
  headers: {
    'X-Quandoo-ApiVersion': '2',
  },
};

export const API_V3_HEADER = {
  headers: {
    'X-Quandoo-ApiVersion': '3',
  },
};

export const API_V4_HEADER = {
  headers: {
    'X-Quandoo-ApiVersion': '4',
  },
};

export const SWITCH_TO_BC_CONFIG = {
  QUANDOO_DOMAIN: '.quandoo.com',
  AUDIT_ENDPOINT: 'oc-api/operations/switch_to_bc',
  BC_LOCATION: {
    // TODO: Update after BC migration
    LOCAL: 'http://local-admin.quandoo.com:8080/#/app/',
    IQA: 'https://admin.int.quandoo.com/#/app/',
    IWEB: 'https://admin.dev.quandoo.com/#/app/',
    TEST: 'https://admin.stg.quandoo.com/#/app/',
    BETA: 'https://beta-admin.quandoo.com/#/app/',
    LIVE: 'https://admin.quandoo.com/#/app/',
  },
};
export const SWITCH_TO_BA_CONFIG = {
  BA_LOCATION: 'quandoob2b://ba/',
};

export const SWITCH_TO_RMA_CONFIG = {
  RMA_LOCATION: 'quandoob2b://dashboard',
};

export const SWITCH_TO_HOST_CONFIG = {
  HOST_LOCATION: 'quandoob2b://host/',
  AUDIT_ENDPOINT: 'oc-api/operations/switch_to_host',
};

export const ENVIRONMENT = {
  LOCAL: ['local-oc.quandoo.com', 'https://oc-api.dev.quandoo.com/', 'https://bc-api.dev.quandoo.com/'],
  IQA: ['oc.int.quandoo.com', 'https://oc-api.int.quandoo.com/', 'https://bc-api.int.quandoo.com/'],
  IWEB: ['oc.dev.quandoo.com', 'https://oc-api.dev.quandoo.com/', 'https://bc-api.dev.quandoo.com/'],
  TEST: ['oc.stg.quandoo.com', 'https://oc-api.stg.quandoo.com/', 'https://bc-api.stg.quandoo.com/'],
  BETA: ['oc.beta.quandoo.com', 'https://beta-8200-api.quandoo.com/', 'https://beta-bc-api.quandoo.com/'],
  LIVE: ['oc.quandoo.com', 'https://8200-api.quandoo.com/', 'https://bc-api.quandoo.com/'],
};
export const INSTANCE_IDS = {
  OC_API: 8200,
  BC_API: 9310,
  MERCHANT_API: 9300,
};
export const OPTIONS = {
  reviews_ratings: [1, 2, 3, 4, 5, 6],
  statuses: {
    redemptions: ['REQUESTED', 'SENT_TO_CUSTOMER', 'REDEEMED', 'PROBLEM'],
    reviews: ['IN_PROGRESS', 'SUBMITTED', 'PUBLISHED', 'NOT_PUBLISHED', 'DENIED', 'INVISIBLE', 'MANUAL_PROCESSING_REQUIRED'],
    reviewsEdit: ['INVISIBLE'],
  },
  countries: ['ARE', 'AUS', 'AUT', 'CHE', 'DEU', 'FIN', 'GBR', 'HKG', 'ITA', 'LBN', 'LUX', 'NLD', 'POL', 'SGP', 'TUR', 'ZAF'],
  locales: {
    languages: {
      en: 'English',
      de: 'Deutsch',
      fi: 'Finnish',
      fr: 'French',
      it: 'Italian',
      nl: 'Dutch',
      pl: 'Polish',
      tr: 'Turkish',
    },
    portal_languages: ['en', 'de', 'fi', 'fr', 'it', 'nl', 'tr', 'hk'],
    countries: {
      AT: 'Austria',
      CH: 'Switzerland',
      DE: 'Deutschland',
      AE: 'United Arab Emirates',
      AU: 'Australia',
      GB: 'United Kingdom',
      HK: 'Hong Kong',
      LB: 'Lebanon',
      SG: 'Singapore',
      ZA: 'South Africa',
      ES: 'Spain',
      FI: 'Finland',
      FR: 'France',
      LU: 'Luxembourg',
      IT: 'Italy',
      NL: 'Netherlands',
      PL: 'Poland',
      TR: 'Turkey',
    },
  },
  destinationSubTypes: [
    { id: 'SMALL', description: 'Small = 5 km' },
    { id: 'MEDIUM', description: 'Medium = 10 km' },
    { id: 'BIG', description: 'Large = 30 km' },
  ],
  bookingPriorities: [
    { id: 1, name: '1 (Lowest)' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10 (Highest)' },
  ],
};
export const USER_TYPES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  DEAL_MANAGER: 'DEAL_MANAGER', // TODO: delete once this user role is deleted from DB
};
export const DESTINATION_TYPES = {
  CONTINENT: { id: 1, name: 'continent' },
  COUNTRY: { id: 2, name: 'country' },
  REGION: { id: 3, name: 'region' },
  CITY: { id: 4, name: 'city' },
  DISTRICT: { id: 5, name: 'district' },
  POI: { id: 6, name: 'poi' },
};
export const RESOURCES = {
  MERCHANT: 'oc-api/operations/merchants',
  SERVICE_CATEGORIES: 'oc-api/operations/service_categories',
  ATTRIBUTES: 'oc-api/operations/attributes',
  CUSTOMERS: 'oc-api/operations/customers',
  REDEMPTION: 'oc-api/operations/redemptions',
  REVIEW: 'oc-api/operations/reviews',
  TAG: 'oc-api/operations/tags',
  USER: 'oc-api/operations/users',
  DESTINATION: 'oc-api/operations/destinations',
  COUNTRY: 'oc-api/operations/countries',
  MERCHANT_CATEGORIES: 'oc-api/operations/categories',
  TIMEZONE: 'oc-api/operations/timezones',
  OBJECT_TYPES: 'oc-api/operations/object_types',
  ROLES: 'oc-api/operations/users/roles',
  SPONSORS: 'oc-api/operations/sponsors',
  CHAINS: 'oc-api/operations/chains',
  DOMAIN: 'oc-api/operations/domain',
  DOCUMENT_CATEGORIES: 'oc-api/operations/document_categories',
  DEFAULT_IMAGES: 'oc-api/operations/defaultImages',
  SEO: 'oc-api/operations/seo_texts',
  FAQ: 'oc-api/operations/faqs',
  RELEASE_NOTES: 'oc-api/operations/release_notes',
  TAGS: 'oc-api/operations/search_tags',
  SUPPORT: 'oc-api/operations/support/merchants',
  MENU_EXTRACT: 'oc-api/operations/menuExtract',
  REDIRECT_TO_QRB: 'oc-api/operations/merchants/redirect-to-qrb',
  LOYALTY_POINTS: 'oc-api/operations/support/loyalty-points/bulk-assignment',
  SOURCES: 'oc-api/operations/merchants/sources'
};
export const MERCHANT_PRODUCTS = {
  FREE_PLUS: 11,
  PROFESSIONAL_WEB: 10,
  PREMIUM_MERCHANT: 8,
  BOOKING_WIDGET: 7,
  BOOKING_MESSAGE: 5,
  LISTING_NON_PARTNER_RESTAURANT: 4,
  LISTING_PARTNER_RESTAURANT: 3,
  MERCHANT_CENTER_BASIC: 1,
  PROSPECT: 12,
  BOOK: 13,
  QRB: 14,
  EXTERNAL_PARTNER: 15,
};
export const MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED = [1, 8, 10, 11];
export const MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED = [8, 10];
export const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
export const TIMES = {
  morning: 'MORNING',
  lunch: 'MIDDAY',
  dinner: 'EVENING',
};
export const AUTHENTICATION = {
  SESSIONS: 'oc-api/operations/sessions',
  PING: 'oc-api/operations/ping',
};
export const IMAGES = {
  LANDSCAPE: {
    TYPE: 'landscape',
    MIN_WIDTH: 1024,
    MIN_HEIGHT: 555,
    ASPECT_RATIO: 1.845,
  },
  SLIDER: {
    TYPE: 'slider',
    MIN_WIDTH: 710,
    MIN_HEIGHT: 384,
    ASPECT_RATIO: 1.85,
  },
  DEFAULT: {
    TYPE: 'default',
    MIN_WIDTH: 1200,
    MIN_HEIGHT: 650,
    ASPECT_RATIO: 1.845,
  },
};
export const FILES_TYPES = {
  AREA_FILES_TYPES: [
    {
      label: 'None',
      value: null,
    },
    {
      label: 'Table Plan',
      value: 'OBJECTS',
    },
    {
      label: 'Default Profile',
      value: 'PROFILE',
    },
    {
      label: 'Tables with combinations',
      value: 'TABLES_WITH_COMBINATIONS',
    },
  ],
};

export const SEARCH_TAGS_TYPES = {
  PRICE: 'PRICE',
  CUISINE: 'CUISINE',
  ESTABLISHMENT_TYPE: 'ESTABLISHMENT_TYPE',
  MEAL_TYPE: 'MEAL_TYPE',
  ATMOSPHERE: 'ATMOSPHERE',
  INTERNET: 'INTERNET',
  PARKING: 'PARKING',
  PAYMENT: 'PAYMENT',
  ACCESSIBILITY: 'ACCESSIBILITY',
  FOOD_RELATED: 'FOOD_RELATED',

  CASH_ONLY_TAG_NAME: 'Cash Only',

  PRICES_TAGS_NAMES: {
    VERY_CHEAP: 'price very cheap',
    CHEAP: 'price cheap',
    AVERAGE: 'price average',
    UPSCALE: 'price upscale',
  },
};

export const CURRENCY = {
  EUR: '€',
  GBP: '£',
  TRY: '₺',
  SGD: '$',
  CHF: 'CHF',
  HKD: '$',
  AUD: '$',
};

export const DISABLED_TABS_FOR_QRB = ['times', 'areas', 'combinations', 'retention', 'employees'];

export const MAX_FRAUDULENT_EMAIL_AMOUNT = 90;



// WEBPACK FOOTER //
// ./src/app/app.constants.js